import { fetcher } from '#lib/backendFetcher';

/**
 * Starts an AI company analysis for a search query.
 * @param {Object} params
 * @param {string} params.prospectQueryId - UUID of the search query
 * @param {string} [params.analysisType='companyFit'] - Analysis type
 * @param {string} params.criteriaText - Free-text criteria for the analysis
 * @param {boolean} [params.includeSocialMedia=false] - Whether to include social media data
 * @param {{leadIds: string[]} | {selectAll: true, filters?: Object}} params.scope - Companies to analyze (see useActionScope)
 * @returns {Promise<Object>}
 */
export const startCompanyAnalysis = async ({
	prospectQueryId,
	analysisType = 'companyFit',
	criteriaText,
	includeSocialMedia = false,
	scope,
}) => {
	return fetcher('/api/v1/leads/analysis/analyze', {
		method: 'POST',
		body: { prospectQueryId, analysisType, criteriaText, includeSocialMedia, ...scope },
	});
};

/**
 * Fetches AI analysis results for given companies scoped to a prospect query.
 * @param {Array<string>} globalCompanyIds - Array of company UUIDs
 * @param {string} prospectQueryId - UUID of the prospect query
 * @returns {Promise<Array<Object>>}
 */
export const fetchAIAnalyses = async (globalCompanyIds, prospectQueryId) => {
	if (!globalCompanyIds || globalCompanyIds.length === 0 || !prospectQueryId) {
		return [];
	}

	const result = await fetcher(
		`/api/v1/leads/analysis/scores?prospectQueryId=${prospectQueryId}&companyIds=${globalCompanyIds.join(',')}`,
	);

	return result.analyses ?? [];
};
